The identifier for the `CandidateProcessHistoryItem`.
